import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { invokePostService, setReRender, toggleRightDrawer, invokeGetService, setDashboardRefresh, handleSnackBar } from "../../../store/global/actions";
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { Grid } from '@material-ui/core';
import { getFieldFormSchema, getFieldSchemaData, generateFieldSchema, fieldFormValidation } from '../../../services/entities/DashboardBuilder.js';
import { useHistory } from "react-router-dom";
import { getDetailsFromUrl } from '../../../services/blueprint';
import { editView } from "../../../store/views/actions";
import { getRightDrawerStatus } from '../../../store/global/selectors';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress.js';
import { updateViewSchema } from '../../../utils/DashboardBuilder.js';
import { uiTypeChildren, urlTypes } from '../../../config/fields.js';
import { findSelectedSchema } from '../../../services/builder/util.js';
import './style.css';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader.js';

const options = {
    form_name_root: "field_form",
    show_errors: "interaction",
    disable_array_add: false,
    disable_array_reorder: true,
    disable_properties: false,
    no_additional_properties: false,
    keep_oneof_values: true,
    disable_array_delete_all_rows: true,
    disable_array_delete_last_row: true,
}

export default function FieldForm({ selectedView, action, onClose, selectedField, parentEntity, widgetId, hyperlinkConfig }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const rightDrawerStatus = useSelector(getRightDrawerStatus);

    const { slug, blueprintId } = getDetailsFromUrl();
    const [schemaValues, setSchemaValues] = useState({});
    const [fieldSchema, setFieldSchema] = useState({});
    const [loading, setLoading] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [formData, setFormData] = useState({});
    const [editorObj, setEditorObj] = useState(null);

    useEffect(() => {
        setLoading(true);
        dispatch(invokeGetService('getBlueprintConstructs', [])).then(resp => {
            if (resp.status) {
                const clusterlets = resp.data?.clusterlets?.filter(item => item.type === 2 || item.type === 3);
                let schema = getFieldFormSchema(parentEntity, clusterlets, resp.data?.views, selectedField);
                let schemaData = getFieldSchemaData(selectedField, parentEntity);

                setFieldSchema(schema);
                setSchemaValues(schemaData);
                setLoading(false);
            }
        }).catch(error => {
            console.error(`Fetching blueprint constructs failed. ${error}`);
        })
    }, []);



    const fieldCustomFormValidation = (schema, value, path) => {
        const fields = parentEntity?.children?.map(item => item.name);
        return fieldFormValidation({ schema, value, path, fields, selectedField })
    }

    
    // Custom argument in hyperlink form
    const modifyQueryParamsFieldsInForm = () => {
        try {
        const containers = document.querySelectorAll('[data-schemapath="field_form.type.hyperlink.urlType.queryParameters"]');
        if (containers) {
            containers?.forEach((container, index) => {
            
                // 1. Change grid size from col-md-12 → col-md-6
                if(!hyperlinkConfig){
                    container.classList.remove("col-md-12");
                    container.classList.add("col-md-6");
                }
            
                // 2. Change Add Row button text
                const addBtn = container.querySelector(".json-editor-btn-add");
                if (addBtn) {
                addBtn.title = "";
                const span = addBtn.querySelector("span");
                if (span) span.textContent = " Add query parameter";
                }
            
                // 3. Insert label "Custom arguments" before the table if not present
                if (!document.getElementById(`custom-arguments-label-${index}`)) {
                const table = container.querySelector("table");
                if (table) {
                    const label = document.createElement("div");
                    label.id = `custom-arguments-label-${index}`;
                    label.textContent = "Add more query parameters for the hyperlink";
                    label.style.marginBottom = "5px";
                    label.style.marginTop = "8px";
                    table.parentNode.insertBefore(label, table);
                }
                }
            
            })

        }
        if(hyperlinkConfig){
                // List of selectors to hide
                const selectors = [
                    '[data-schemapath="field_form.name"]',
                    '[data-schemapath="field_form.desc"]',
                ];
                const root = document.getElementById('field_form');
                if (!root) return;

                selectors?.forEach(sel => {
                    const el = root.querySelector(sel);
                    if (el) { 
                        el.style.display = "none"; 
                    }
                });

                const unit = '[data-schemapath="field_form.type.unit"]'
                const allUnitElements = root.querySelectorAll(unit);
                allUnitElements?.forEach(el => {
                    if (el) { 
                        el.style.display = "none"; 
                    }
                });

                const defaultVal = '[data-schemapath="field_form.type.defaultVal"]'
                const allDefaultVal = root.querySelectorAll(defaultVal);
                allDefaultVal?.forEach(el => {
                    if (el) { 
                        el.style.display = "none"; 
                    }
                });

                const visibilityField =  '[data-schemapath="field_form.visible"]'
                const allVisibilityFields = root.querySelectorAll(visibilityField);
                allVisibilityFields?.forEach(el => {
                    if (el) { 
                        el.style.display = "none"; 
                    }
                });

                const typeContainer = document.querySelector('[data-schemapath="field_form.type"]');
                if (typeContainer) {
                    // Find the first <b>, <label>, and <select> inside this typeContainer
                    const bEl = typeContainer.querySelector('b');
                    const labelEl = typeContainer.querySelector('label');
                    const selectEl = typeContainer.querySelector('select');

                    if (bEl) bEl.style.display = 'none';
                    if (labelEl) labelEl.style.display = 'none';
                    if (selectEl) selectEl.style.display = 'none';
                }
                
        }
        } catch (error) {
            console.error(`Modifying query parameters in the form failed. ${error}`);
        }
    }


    const onChangeJsonEditor = (data, jsonEditor) => {
        modifyQueryParamsFieldsInForm();
        setEditorObj(jsonEditor);
        setFormData(data);
    }

    const clearErrors = () => {
        const errorDivs = document.querySelectorAll('.validation-error');
        for (let i = 0; i < errorDivs.length; i++) {
            errorDivs[i].remove();
        }
    };


    const showCustomValidationErrors = (errors) => {
        errors.forEach(error => {
            const divPresent = document.getElementById(`validation-error-${error.path}`);
            if (!divPresent) {
                const inputWrapper = document.querySelectorAll(`[data-schemapath="${error.path}"]`)[0]
                const input = inputWrapper.querySelectorAll('.form-control')[0]
                input?.insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica;" >${error.message}</p>`);
            }
        })
    }


    const customValidation = () => {
        let errors = [];
        const fields = parentEntity?.children?.map(item => item.name);

        if (formData.type.select) {
            errors.push({
                path: "field_form.type",
                property: 'format',
                message: "Type is required"
            });

        }
        if(selectedField?.name !== formData?.name && fields?.includes(formData?.name)){
            errors.push({
                path: "field_form.name",
                property: 'format',
                message: "Field already exists"
            });
        }
        
        return errors;
    }


    const onSubmit = () => {
        clearErrors();
        const editorValidationErrors = editorObj.validate();
        const customValidationErrors = customValidation()
        showCustomValidationErrors(customValidationErrors)
        if ([...editorValidationErrors, ...customValidationErrors].length > 0) {
            editorObj.showValidationErrors(editorValidationErrors);
            return;
        }

        setIsUpdating(true);

        const payload = { name: formData.name, desc: formData.desc, type: Object.keys(formData.type)[0], unit: formData.type.unit };
        const parseDefaultValue = (value) => {
            try {
                return JSON.parse(value);
            } catch {
                return value;
            }
        };

        if (selectedField?.viewCopy) payload.viewCopy = true;
        if (selectedField?.collection) payload.collection = selectedField.collection;
        if (formData.type.axis && formData.type.axis !== 'select') payload.axis = formData.type.axis;
        if (formData.type.step) payload.step = Number(formData.type.step);
        if (formData.type.maxval) payload.maxval = formData.type.maxval;
        if (formData.type.minval) payload.minval = formData.type.minval;
        if (formData.type.defaultVal) payload.default = parseDefaultValue(formData.type.defaultVal);
        if (selectedField?.viewCopy && formData.visible !== undefined){
            payload.visible = formData.visible === "true" || formData.visible === true ? true : false; 
        }
       
        if (parentEntity?.type === "table") {
            const urlType = formData?.type?.hyperlink?.urlType;
            if (urlType) {
                const { viewname, instance, clusterlettype, url,  queryParameters} = urlType;
                const filteredQueryParams = queryParameters?.filter(item => item?.Key !== "" && item?.Value !== "") || [];
                if (viewname) {
                    payload.viewname = viewname;
                    payload.instance = instance;
                }
                if (clusterlettype) {
                    payload.clusterlettype = clusterlettype;
                    payload.instance = instance;
                }
                if((viewname || clusterlettype) && filteredQueryParams?.length > 0){
                    payload.queryparams = filteredQueryParams;
                }else{
                    delete payload.queryparams;
                }
                if (url) payload.url = url;
            }
        }

        let uiTypeChildrenObj = uiTypeChildren();

        if (action === "create") {
            payload.children = uiTypeChildrenObj[payload.type] ?? [];
            if (parentEntity?.type === 'chart-rangeplot') {
                payload.children = uiTypeChildrenObj['chart-rangeplot']?.[1]?.children;
            }

            const newField = generateFieldSchema({ ...payload });
            const updatedView = updateViewSchema(selectedView, 'add', { parentId: parentEntity.id, newItem: newField });
            const updatedWidget = findSelectedSchema({ schemas: updatedView.view_schema, id: widgetId });
            
            dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: updatedWidget }));
            handleViewUpdate(updatedView);
        } else if (action === 'edit') {
            if (selectedField.type !== payload.type && urlTypes.includes(payload.type)) {
                payload.children = uiTypeChildrenObj[payload.type];
            }
            const updatedView = updateViewSchema(selectedView, 'edit', { id: selectedField.id, updatedData: payload });
            const updatedWidget = findSelectedSchema({ schemas: updatedView.view_schema, id: widgetId });
            dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: updatedWidget }));
            handleViewUpdate(updatedView);
        }
    }

    const handleViewUpdate = (updatedView) => {
        dispatch(invokePostService('updateView', { view: updatedView }, [updatedView?._id])).then(response => {
            setIsUpdating(false);
            if (response.status === true) {
                dispatch(handleSnackBar({ open: true, message: `Field ${action === "create" ? "created" : "updated"}`, severity: 'success' }));
                
                dispatch(editView(updatedView));
                onClose();
            } else {
                if (response.code === 255) {
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    if (rightDrawerStatus === true) dispatch(toggleRightDrawer());
                }
            }
        })
    }

    return (
        <>
            {loading && <SkeletonLoader isLabelled type="form" rows={4} />}

            {!loading && Object.keys(fieldSchema).length > 0 &&
                <JsonTableEditor options={options} schema={fieldSchema} schemaValues={schemaValues} validation={fieldCustomFormValidation} onChangeJsonEditor={onChangeJsonEditor} editorId={"field_form"} />
            }
            <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginTop: '30vh' } : { display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel forceCancel root={options.form_name_root} updateDisable={isUpdating || loading} content={isUpdating ? (action === "create" ? "Creating.." : "Updating..") : (action === "create" ? "Create" : "Update")} onUpdate={onSubmit} onCancel={onClose} />
            </Grid>
        </>
    )



}